import axios from 'axios';

import { HSCAN_BACKEND_API_URL } from '../../env';

export interface ExplicitConsent {
  content: { modality: string; studyDate: string }[];
  isOnlinePayment: boolean;
}

export const requestExplicitConsent = (uuid: string) => {
  return axios.get<ExplicitConsent>(
    `${HSCAN_BACKEND_API_URL}/explicit-consent/${uuid}`,
  );
};

export const grantExplicitConsent = (uuid: string) => {
  return axios.put(`${HSCAN_BACKEND_API_URL}/explicit-consent/${uuid}`);
};
